<template>
  <div class="edit-exercise">
    <div class="card card--white">
      <div class="card card--container">
      <form @submit="save">
        <button icon class="print" @click="print()" v-if="!readonly && exercise.id"><h-icon>print</h-icon></button>
        <div class="help-text">Disabled exercises will not be assigned to clients</div>
        <v-switch :label="exercise.active ? 'Enabled' : 'Disabled'" v-model="exercise.active" :disabled="readonly"/>
        <h-input
          v-model="exercise.short_description"
          label="Title"
          :disabled="readonly"
          id="exercise-short-description"
          required/>
        <h-input
          v-model="exercise.description"
          label="Description"
          :multi-line='true'
          :disabled="readonly"
          required
          id="exercise-description"
          />
        <h-input v-model="exercise.how" label="How"  :multi-line='true' :disabled="readonly" id="exercise-how"/>
        <h-input v-model="exercise.why" label="Why" :multi-line='true' :disabled="readonly" id="exercise-why"/>
        <h-select v-model="exercise.lesson" label="Linked Lesson" :disabled="readonly" :items="lessons" item-value="id" item-text="title" id="exercise-linked-lesson"/>
        <h-input type="number" v-model="exercise.buffer" label="How many days before the exercise can be repeated" :disabled="readonly" required id="exercise-buffer"/>
        <h-input type="number" v-model="exercise.available_for" label="How many days will the client have before exercise expires" :disabled="readonly" required id="exercise-length"/>
        <h-input type="checkbox" label="Always assign if available" v-model="exercise.always" :disabled="readonly" id="exercise-always"/>
        <h-select 
          v-model="exercise.themes[0]" 
          label="Area Of Focus" 
          :items="areasOfFocus" 
          item-text="name" 
          item-value="id" 
          value="id" 
          :required="true" />
        <div class="small-top">Exercise is only available on the following days (select all if always available)</div>
        <div class="content-wrap" id="exercise-work-week">
          <div v-for="n in 7" :key="n" class="simple-content">
            <v-checkbox
              :key="n"
              :value="n - 1"
              :label="DAYS_OF_THE_WEEK[n - 1]"
              v-model="exercise.only_on"
              :disabled="readonly"
            ></v-checkbox>
          </div>
        </div>
        <v-alert type="error" :value="error">
          This is a error alert.
        </v-alert>
        <div class="section" v-if="editable">
          <div class="space-between">
            <span>
              <h-btn class="primary" type="submit" :disabled="readonly">Save</h-btn>
              <h-btn @click="$emit('cancel')" type="button">Cancel</h-btn>
            </span>
            <h-btn v-if="exercise.id && !readonly" type="button" class="error" @click="destroy">Delete</h-btn>
          </div>
          <div class="help-text" v-if="readonly">
            This is managed by Habit Tech.
          </div>
        </div>
        <div v-else class="section">
          <h-btn class="primary" @click="$emit('cancel')" type="button">Close</h-btn>
        </div>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
import axios from "axios";

const DAYS_OF_THE_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

const EXERCISE_STORE = "CoachHabitProgramTemplateExercises";
const LESSONS_STORE = "CoachModuleLessons";

export default {
  props: ["exercise", "error", "areasOfFocus", "editable"],
  created() {
    dataStore
      .findAll(LESSONS_STORE, {limit: 100}, {force: true})
      .then(r => {
        this.lessons = r;
      });
  },
  data() {
    return {
      DAYS_OF_THE_WEEK,
      userId: User.id,
      displayAdd: true,
      lessons: []
    };
  },
  computed: {
    readonly() {
      return this.exercise.id && !this.exercise.editable;
    },
  },
  methods: {
    save($event) {
      $event.preventDefault();
      this.$emit("saveExercise", this.exercise);
    },
    destroy() {
      dataStore.destroy(EXERCISE_STORE, this.exercise.id).then(() => {
        this.$emit("deleted", this.exercise);
      });
    },
    print() {
      axios.get(`${process.env.VUE_APP_API_URL}coaches/template-exercises/${this.exercise.id}/print/`, {
        responsetype: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.exercise.title}.pdf`);
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.edit-exercise {
  .print {
    float: right;
    text-decoration: none;
  }
}

</style>
